import { render } from "./WaveCommand7.vue?vue&type=template&id=26da8a5c"
import script from "./WaveCommand7.vue?vue&type=script&lang=js"
export * from "./WaveCommand7.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ami-website\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__